// Libs
import { createSelector } from 'reselect'
import _keys from 'lodash/keys'

import reopenJobOperations$ from './reopenJobOperations'

export default createSelector(
  [
    reopenJobOperations$,
  ],
  (operations) => {
    const firstKey = _keys(operations)[0]

    if (firstKey) {
      return operations[firstKey]
    }

    return null
  }
)
